module.exports = __webpack_public_path__ + "img/ezwrite6-platform-icon_android.4a29f33c.svg";